import React, { Children } from 'react';
import { Link } from 'react-router-dom';
export const GallerySection = () => {
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/b7nMAHmFSWwNcK7kP42Wbs/image.png',
    alt: 'Colorful outdoor soft play setup with bounce house'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9Tt6GwQvyMgZVSbNU7vNgt/IMG_7269.jpg',
    alt: 'White bounce house with ball pit at outdoor party'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/fHjgGa5DvCkad5Wu1dYuzC/image.png',
    alt: 'Birthday girl in pink tutu at luxury white bounce house party'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/wP3K7rjpRnCgXvEgqW7d11/image.png',
    alt: 'Toddler enjoying white bounce house'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/oHX9M7bVgjwPqYhtRUEUxv/IMG_3799.jpg',
    alt: 'Children playing with soft play equipment and ball pit'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jUx7e6Etg7Kwic5DTbzcyd/IMG_7265.jpg',
    alt: 'Happy child playing in ball pit'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4ahygBzjP7KFSBcVHMXDf1/IMG_7263.jpg',
    alt: 'Child playing with colorful soft play equipment'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/qwHF4LjHDu52DBvNP4NUVr/664F11FA-C809-4AAF-A65E-0D45FBC205CB.jpg',
    alt: 'Children playing on white castle bounce house'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/26nT2UWgzzFgqQi4jGRrqP/image.png',
    alt: 'Child enjoying outdoor soft play party'
  }];
  return <section id="gallery" className="bg-white py-12 md:py-20" data-id="element-206">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <div className="text-center" data-id="element-208">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-209">Play in Action</h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-500" data-id="element-210">
            See how our soft play equipment creates magical moments for little
            ones
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-211">
          {images.map((image, index) => <div key={index} className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-212">
              <img src={image.src} alt={image.alt} className={`w-full h-96 hover:scale-105 transition-transform duration-300 ${index === 0 ? 'object-cover object-center' : index === 2 ? 'object-cover object-center rotate-90' : index === 3 ? 'object-cover object-center' : index === 5 ? 'object-cover object-top' : index === 8 ? 'object-cover object-top' : 'object-cover'}`} data-id="element-213" />
            </div>)}
        </div>
        <div className="mt-10 text-center flex flex-wrap gap-4 justify-center" data-id="element-214">
          <Link to="/cart" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-secondary-500 hover:bg-secondary-600 transition" onClick={() => window.scrollTo(0, 0)} data-id="element-215">
            Book Now
          </Link>
          <Link to="/#services" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600 transition" data-id="element-216">
            Explore Our Services
          </Link>
        </div>
      </div>
    </section>;
};